export enum PolicyScopeFormStep {
  DETAILS = 'Basic Details',
  REGULATIONS = 'Regulations',
  RIGHTS = 'Rights',
  PURPOSES = 'Purposes',
}
